// extracted by mini-css-extract-plugin
module.exports = {"image":"image_image__JJs1J"};